export default __webpack_public_path__ + "static/media/corporate.6a08d88b.jpg";